export const T01_01 = {
    "selectedValueColumn": "CustomerName",
    "selectedTitle": "Sales",
    "visuals": [
        {
            "title": "Sales Performance",
            "visual": [
                {
                    "columns": 12,
                    "rows": 1,
                    "visual": {
                        "id": 14,
                        "type": "summary",
                        "colorTheme": "colorTheme1",
                        "title": "Sales Summary Performance",
                        "binding": {
                            "data": {
                                "title": '',
                                "value": '',
                                "displayTarget": true,
                                "endpoint": "T01.2",
                                "parameters": [
                                    { "key": "FromMonth", "value": "2024" },
                                    { "key": "FromYear", "value": "1" },
                                    { "key": "ToMonth", "value": "2024" },
                                    { "key": "ToYear", "value": "1" },
                                    { "key": "AgentCode", "value": "" },
                                    { "key": "ConfigTypeCode", "value": "" },
                                    { "key": "CustomerName", "value": "" }
                                ]
                            },
                            "context": {
                                "point": {
                                    "onClick": {

                                    }
                                }
                            }
                        }
                    }
                },
                {
                    "columns": 4,
                    "rows": 1,
                    "visual": {
                        "id": 14,
                        "type": "pie",
                        "colorTheme": "colorTheme1",
                        "title": "Lung Portfolio",
                        "binding": {
                            "data": {
                                "title": 'ItemName',
                                "value": 'Share',
                                "tooltip": 'ActualSales',
                                "currency": true,
                                "percent": true,
                                "endpoint": "T01.1",
                                "parameters": [
                                    { "key": "FromMonth", "value": "2024" },
                                    { "key": "FromYear", "value": "1" },
                                    { "key": "ToMonth", "value": "2024" },
                                    { "key": "ToYear", "value": "1" },
                                    { "key": "AgentCode", "value": "" },
                                    { "key": "ConfigTypeCode", "value": "" },
                                    { "key": "CustomerName", "value": "" },
                                    { "key": "ItemGroupCode", "value": "OT1" }
                                ]
                            },
                            "context": {
                                "point": {
                                    "onClick": {

                                    }
                                }
                            }
                        }
                    }
                },
                {
                    "columns": 8,
                    "rows": 2,
                    "visual": {
                        "id": 1,
                        "type": "combo",
                        "colorTheme": 'colorTheme1',
                        "title": "Actual vs Target (% Performance)",
                        "orientation": "vertical",
                        "xAxis": "",
                        "yAxis": "",
                        "binding": {
                            "data": {
                                "series": [
                                    {
                                        "name": 'Sales',
                                        "value": 'Sales',
                                        "type": 'column'
                                    },
                                    {
                                        "name": 'Target',
                                        "value": 'Target',
                                        "type": 'column'
                                    },
                                    {
                                        "name": 'Performance %',
                                        "value": 'Performance',
                                        "type": 'line',
                                        "percent": true
                                    }
                                ],
                                "title": "MonthName",
                                "endpoint": "T01.3",
                                "parameters": [
                                    { "key": "FromMonth", "value": "2024" },
                                    { "key": "FromYear", "value": "1" },
                                    { "key": "ToMonth", "value": "2024" },
                                    { "key": "ToYear", "value": "1" },
                                    { "key": "AgentCode", "value": "" },
                                    { "key": "ConfigTypeCode", "value": "" },
                                    { "key": "CustomerName", "value": "" }
                                ]
                            },
                            "context": {
                                "point": {
                                    "onClick": {
                
                                    }
                                }
                            }
                        }
                    }
                },
                {
                    "columns": 4,
                    "rows": 1,
                    "visual": {
                        "id": 14,
                        "type": "pie",
                        "colorTheme": "colorTheme1",
                        "title": "Breast Portfolio",
                        "binding": {
                            "data": {
                                "title": 'ItemName',
                                "value": 'Share',
                                "tooltip": 'ActualSales',
                                "currency": true,
                                "percent": true,
                                "endpoint": "T01.1",
                                "parameters": [
                                    { "key": "FromMonth", "value": "2024" },
                                    { "key": "FromYear", "value": "1" },
                                    { "key": "ToMonth", "value": "2024" },
                                    { "key": "ToYear", "value": "1" },
                                    { "key": "AgentCode", "value": "" },
                                    { "key": "ConfigTypeCode", "value": "" },
                                    { "key": "CustomerName", "value": "" },
                                    { "key": "ItemGroupCode", "value": "OT2" }
                                ]
                            },
                            "context": {
                                "point": {
                                    "onClick": {
                                        
                                    }
                                }
                            }
                        }
                    }
                }
            ]
        },
        {
            "title": "Variance",
            "visual": [
                {
                    "columns": 12,
                    "rows": 2,
                    "visual": {
                        "id": 1,
                        "type": "advancedTable",
                        "colorTheme": 'colorTheme1',
                        "title": "Product Growth and Performance",
                        "binding": {
                            "data": {
                                "columns": [
                                    {
                                        "name": 'Products',
                                        "columnName": 'ItemName',
                                        "width": '200px',
                                        "align": "left",
                                        "sortable": true,
                                        "sum": false
                                    },
                                    {
                                        "name": 'Sales',
                                        "columnName": 'ActualSales',
                                        "width": '140px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true,
                                    },
                                    {
                                        "name": 'Target',
                                        "columnName": 'TargetSales',
                                        "width": '140px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true,
                                    },
                                    {
                                        "name": 'Performance %',
                                        "columnName": 'Performance',
                                        "width": '150px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": false,
                                        "percent": true
                                    },
                                    {
                                        "name": 'LY Sales',
                                        "columnName": 'LYSales',
                                        "width": '140px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true,
                                    },
                                    {
                                        "name": 'Growth %',
                                        "columnName": 'Growth',
                                        "width": '140px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": false,
                                        "percent": true
                                    },
                                    {
                                        "name": 'Variance',
                                        "columnName": 'Variance',
                                        "width": '140px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    }
                                ],
                                "title": "ItemName",
                                "endpoint": "T01.4",
                                "parameters": [
                                    { "key": "FromMonth", "value": "2024" },
                                    { "key": "FromYear", "value": "1" },
                                    { "key": "ToMonth", "value": "2024" },
                                    { "key": "ToYear", "value": "1" },
                                    { "key": "AgentCode", "value": "" },
                                    { "key": "ConfigTypeCode", "value": "" },
                                    { "key": "CustomerName", "value": "" },
                                ]
                            },
                            "context": {
                                "point": {
                                    "onClick": {
                                    }
                                }
                            }
                        }
                    }
                }
            ]
        },
        {
            "title": "Comparative",
            "visual": [
                {
                    "columns": 12,
                    "rows": 2,
                    "visual": {
                        "id": 1,
                        "type": "advancedTable",
                        "colorTheme": 'colorTheme1',
                        "title": "Comparative Monthly Sales",
                        "binding": {
                            "data": {
                                "columns": [
                                    {
                                        "name": 'Products',
                                        "columnName": 'ItemName',
                                        "width": '200px',
                                        "align": "left",
                                        "sortable": true,
                                        "sum": false
                                    },
                                    {
                                        "name": 'Jan',
                                        "columnName": 'Jan',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Feb',
                                        "columnName": 'Feb',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Mar',
                                        "columnName": 'Mar',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Apr',
                                        "columnName": 'Apr',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'May',
                                        "columnName": 'May',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Jun',
                                        "columnName": 'Jun',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Jul',
                                        "columnName": 'Jul',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Aug',
                                        "columnName": 'Aug',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Sep',
                                        "columnName": 'Sep',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Oct',
                                        "columnName": 'Oct',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Nov',
                                        "columnName": 'Nov',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Dec',
                                        "columnName": 'Dec',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Total Sales',
                                        "columnName": 'TotalSales',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    },
                                    {
                                        "name": 'Projection',
                                        "columnName": 'Variance',
                                        "width": '125px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                    }
                                ],
                                "title": "ItemName",
                                "endpoint": "T01.5",
                                "parameters": [
                                    { "key": "FromMonth", "value": "2024" },
                                    { "key": "FromYear", "value": "1" },
                                    { "key": "ToMonth", "value": "2024" },
                                    { "key": "ToYear", "value": "1" },
                                    { "key": "AgentCode", "value": "" },
                                    { "key": "ConfigTypeCode", "value": "" },
                                    { "key": "CustomerName", "value": "" },
                                ]
                            },
                            "context": {
                                "point": {
                                    "onClick": {
                                    }
                                }
                            }
                        }
                    }
                }
            ]
        }
    ],
}